module.exports = __webpack_public_path__ + "img/logo_inside.750b69a5.png";